// extracted by mini-css-extract-plugin
export default {"Container":"zzXKioHc57h8PFuXh12Q","Status":"BeCVcIL5TFvOKcFMdtFC","UninstallButton":"tz8NGMAWT8KvsXbIdKGC"};